import { render, staticRenderFns } from "./InstitutionDetailsView.vue?vue&type=template&id=ed151b18"
import script from "./InstitutionDetailsView.vue?vue&type=script&lang=js"
export * from "./InstitutionDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports